import React from "react";
import "../styles/generalStyle.css";
import "./Landing.css";

export default function PrivacyPolicy() {
  return (
    <div className="lp">
      <div className="lp-container" style={{ paddingTop: 60, paddingBottom: 60 }}>
        <h1>Política de Privacidad</h1>
        <p><strong>Última actualización:</strong> [Coloca aquí la fecha actual]</p>

        <p>
          En <strong>Música a la Carta</strong>, valoramos y respetamos la privacidad de nuestros usuarios.
          Esta Política de Privacidad explica cómo recopilamos, utilizamos y protegemos la información
          proporcionada a través de nuestra aplicación móvil y sitio web.
        </p>

        <h2>1. Información que recopilamos</h2>

        <h3>a) Información para crear canciones</h3>
        <p>
          Cuando el usuario utiliza nuestro formulario o chat para solicitar una canción personalizada,
          puede compartir nombres, fechas, historias personales, dedicatorias y otros detalles necesarios
          para crear la letra y música.
        </p>
        <p>
          Esta información se utiliza exclusivamente para generar la canción personalizada solicitada.
        </p>

        <h3>b) Información de cuenta</h3>
        <p>
          Al registrarse, podemos recopilar el correo electrónico y datos básicos de autenticación.
          Esta información se utiliza únicamente para crear y administrar la cuenta del usuario,
          permitir el inicio de sesión y acceder a su panel personal.
        </p>

        <h2>2. Uso de la información</h2>
        <p>
          La información recopilada se utiliza exclusivamente para:
        </p>
        <ul>
          <li>Generar canciones personalizadas</li>
          <li>Entregar la canción y letra al usuario</li>
          <li>Permitir el acceso a la cuenta</li>
          <li>Mejorar la experiencia en la plataforma</li>
          <li>Enviar comunicaciones relacionadas con Música a la Carta</li>
        </ul>

        <p>
          No vendemos ni compartimos información personal con terceros para fines comerciales externos.
        </p>

        <h2>3. Seguridad de la información</h2>
        <p>
          Implementamos medidas técnicas y organizativas razonables para proteger la información.
          Sin embargo, ningún sistema es completamente seguro.
        </p>

        <h2>4. Uso del contenido generado</h2>
        <p>
          Una vez entregada la canción y letra, el usuario es responsable del uso que haga del contenido.
        </p>

        <h2>5. Eliminación de datos</h2>
        <p>
          Puede solicitar la eliminación de su cuenta escribiendo a:
          <br />
          <strong>musicaalacartaapp@gmail.com</strong>
        </p>

        <h2>6. Cambios en esta política</h2>
        <p>
          Nos reservamos el derecho de actualizar esta Política de Privacidad en cualquier momento.
        </p>

        <h2>7. Contacto</h2>
        <p>
          Para cualquier duda:
          <br />
          <strong>musicaalacartaapp@gmail.com</strong>
        </p>
      </div>
    </div>
  );
}